var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35 14h-26a3.009 3.009 0 0 0 -3 3v12.13a3.657 3.657 0 0 1 1-.13h30a3.657 3.657 0 0 1 1 .13v-12.13a3.009 3.009 0 0 0 -3-3zm-20.16 4.55a18.167 18.167 0 0 0 -1.9 3.79 18.549 18.549 0 0 0 -.95 3.8 1 1 0 0 1 -.99.86.708.708 0 0 1 -.14-.01 1 1 0 0 1 -.85-1.13 20.83 20.83 0 0 1 1.05-4.2 20.377 20.377 0 0 1 1.19-2.66h-2.25a1 1 0 0 1 0-2h4a1.006 1.006 0 0 1 .88.52 1.025 1.025 0 0 1 -.04 1.03zm10 0a18.167 18.167 0 0 0 -1.9 3.79 18.549 18.549 0 0 0 -.95 3.8 1 1 0 0 1 -.99.86.708.708 0 0 1 -.14-.01 1 1 0 0 1 -.85-1.13 20.83 20.83 0 0 1 1.05-4.2 20.377 20.377 0 0 1 1.19-2.66h-2.25a1 1 0 0 1 0-2h4a1.006 1.006 0 0 1 .88.52 1.025 1.025 0 0 1 -.04 1.03zm10 0a18.167 18.167 0 0 0 -1.9 3.79 18.549 18.549 0 0 0 -.95 3.8 1 1 0 0 1 -.99.86.708.708 0 0 1 -.14-.01 1 1 0 0 1 -.85-1.13 20.83 20.83 0 0 1 1.05-4.2 20.377 20.377 0 0 1 1.19-2.66h-2.25a1 1 0 0 1 0-2h4a1.006 1.006 0 0 1 .88.52 1.025 1.025 0 0 1 -.04 1.03z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.94 8.15-1.74 4.85h-12.44l-1.7-4.52a1.03 1.03 0 0 1 .28-1.11 1 1 0 0 1 1.13-.12l3.19 1.71 2.47-4.45a1 1 0 0 1 1.77.05l2.11 4.36 3.5-1.98a1 1 0 0 1 1.43 1.21z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 38,
    y: 34,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 7a3 3 0 0 0 -3 3v2a3 3 0 0 0 6 0v-2a3 3 0 0 0 -3-3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 36a1 1 0 0 1 -1-1v-21a1 1 0 0 1 2 0v21a1 1 0 0 1 -1 1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 36h-20a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 30h-30a3 3 0 0 0 -3 3v8a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3v-8a3 3 0 0 0 -3-3zm-5 10h-20a3 3 0 0 1 0-6h20a3 3 0 0 1 0 6z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.ddc03a6a1bf14d09edbb1869ecd39e46.svg";
export { ForwardRef as ReactComponent };